export function formatMs(ms: number): string {
  const total = Math.floor(ms / 1000);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const mm = String(m).padStart(2, '0');
  const ss = String(s).padStart(2, '0');
  return h > 0 ? `${h}:${mm}:${ss}` : `${m}:${ss}`;
}

interface TimerProps {
  elapsedMs: number;
  running: boolean;
  onToggle: () => void;
}

export function Timer({ elapsedMs, running, onToggle }: TimerProps) {
  return (
    <button
      type="button"
      className="timer"
      onClick={onToggle}
      aria-label={running ? 'Pause timer' : 'Resume timer'}
      title={running ? 'Pause' : 'Resume'}
    >
      <span className="time">{formatMs(elapsedMs)}</span>
      <span className="timer-icon">{running ? '⏸' : '▶'}</span>
    </button>
  );
}
